module.exports = __webpack_public_path__ + "img/z_flip.1caf6121.jpg";